var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.746,
    height: 24.466,
    viewBox: "0 0 38.746 24.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-svgrepo-com",
    transform: "translate(0 -37.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M0,37.748V62.214H38.746V37.748Zm37.109,1.638V40.6L19.373,53.074,1.637,40.6V39.386ZM1.637,60.577V42.6L18.9,54.744a.811.811,0,0,0,.471.15.8.8,0,0,0,.469-.15L37.108,42.6V60.577Z",
    fill: "#ee2c3c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.4c27745bada0f6009fd13bdb84aee25d.svg";
export { ForwardRef as ReactComponent };